import { useSetRecoilState } from  'recoil'

import { isOpenOverlayState } from '../globalStates/isOpenOverlayState'

export function useLoadingOverlay() {
  const setOpen = useSetRecoilState(isOpenOverlayState)


  const openLoading = () => setOpen(true)
  const closeLoading = () => setOpen(false)

  return {
    openLoading,
    closeLoading
  }
}